import {
    FETCH_PERSONAL_RECORDS,
    FETCH_PERSONAL_RECORDS_FETCHING,
    FETCH_PERSONAL_RECORDS_SUCCESS,
    FETCH_PERSONAL_RECORDS_FAIL,
    DELETE_PERSONAL_RECORD,
    DELETE_PERSONAL_RECORD_SUCCESS,
    DELETE_PERSONAL_RECORD_FAIL,
    ADD_PERSONAL_RECORD,
    ADD_PERSONAL_RECORD_SUCCESS,
    ADD_PERSONAL_RECORD_FAIL,
    UPDATE_PERSONAL_RECORD,
    UPDATE_PERSONAL_RECORD_SUCCESS,
    UPDATE_PERSONAL_RECORD_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: [],
    personalRecordsFetching: false,
    personalRecordsFetchFail: false,
    personalRecordDeleteFail: false,
    personalRecordDeleteSuccess: false,
    presonalRecordAddSuccess: false,
    personalRecordAddFail: false,
    updatePersonalRecordSuccess: false,
    updatePersonalRecordFail: false
};

// ======= Fetching Handlers =======
const fetchPersonalRecordsFetching = (state, action) => {
    return {
        ...state,
        personalRecordsFetching: true,
        personalRecordsFetchFail: false
    };
};

const fetchPersonalRecordsSuccess = (state, action) => {
    const { displayName, data } = action;
    return {
        ...state,
        data: { ...state.data, [displayName]: data },
        personalRecordsFetching: false,
        personalRecordsFetchFail: false
    };
};

const fetchPersonalRecordsFail = (state, action) => {
    return {
        ...state,
        personalRecordsFetching: false,
        personalRecordsFetchFail: true
    };
};

const personalRecordDeleted = (success) => (state, action) => {
    return {
        ...state,
        personalRecordDeleteSuccess: success,
        personalRecordDeleteFail: !success
    };
};

const personalRecordAdded = (success) => (state, action) => {
    return {
        ...state,
        presonalRecordAddSuccess: success,
        personalRecordAddFail: !success
    };
};

const personalRecordUpdated = (success) => (state, action) => {
    return {
        ...state,
        updatePersonalRecordSuccess: success,
        updatePersonalRecordFail: !success
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_PERSONAL_RECORDS_FETCHING]: fetchPersonalRecordsFetching,
    [FETCH_PERSONAL_RECORDS_SUCCESS]: fetchPersonalRecordsSuccess,
    [FETCH_PERSONAL_RECORDS_FAIL]: fetchPersonalRecordsFail,
    [DELETE_PERSONAL_RECORD_SUCCESS]: personalRecordDeleted(true),
    [DELETE_PERSONAL_RECORD_FAIL]: personalRecordDeleted(false),
    [ADD_PERSONAL_RECORD_SUCCESS]: personalRecordAdded(true),
    [ADD_PERSONAL_RECORD_FAIL]: personalRecordAdded(false),
    [UPDATE_PERSONAL_RECORD_SUCCESS]: personalRecordUpdated(true),
    [UPDATE_PERSONAL_RECORD_FAIL]: personalRecordUpdated(false)
};

// ======= Default Action ======
export default function personalRecords(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchPersonalRecords(displayName, evictCache) {
    return {
        displayName: displayName,
        type: FETCH_PERSONAL_RECORDS,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deletePersonalRecord(displayName, personalRecord) {
    return {
        type: DELETE_PERSONAL_RECORD,
        displayName,
        personalRecord
    };
}

export function addPersonalRecord(displayName, personalRecord) {
    return {
        type: ADD_PERSONAL_RECORD,
        displayName,
        personalRecord
    };
}

export function updatePersonalRecord(personalRecord) {
    return {
        type: UPDATE_PERSONAL_RECORD,
        personalRecord
    };
}

export const getPersonalRecords = (state) => {
    return state.personalRecords.data ? state.personalRecords.data : null;
};

export const getPersonalRecordsByUserId = (state, userId) => {
    return state.personalRecords.data[userId] ? state.personalRecords.data[userId] : null;
};

export const isPersonalRecordDeleteSuccess = (state) => {
    return state.personalRecords.personalRecordDeleteSuccess;
};

export const isPersonalRecordAddSuccess = (state) => {
    return state.personalRecords.presonalRecordAddSuccess;
};

export const isPersonalRecordUpdateSuccess = (state) => {
    return state.personalRecords.updatePersonalRecordSuccess;
};

export const isPersonalRecordsFetching = (state) => {
    return state.personalRecords.personalRecordsFetching;
};
